/* THEME TOGGLING (Section Observer for Data-Theme) */

export function initThemeToggling() {
  const sections = document.querySelectorAll('[data-theme]');
  if (!sections.length) return;

  let current = '';

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const theme = entry.target.dataset.theme;
      if (theme === current) return;
      current = theme;
      document.body.classList.toggle('on-light-bg', theme === 'light');
      document.body.classList.toggle('on-dark-bg', theme !== 'light');
    });
  }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });

  sections.forEach(s => observer.observe(s));
}


